import styled from "styled-components";
interface IndicatorProps {
  active: boolean;
}

export const DescriptionSectionWrapper = styled.section`
  margin-inline: 105px;
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ImageStyled = styled.img`
  width: 90%;
  height: 90%;
`;

export const TextWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: center;
  transform: translateY(-40px);
`;

export const TitleText = styled.span`
  font-weight: 700;
  font-size: 24px;
  color: #261b6a;
`;

export const DescriptionText = styled.span`
  font-weight: 400;
  font-size: 16px;
  color: #261b6a;
`;

export const IndicatorWrapper = styled.span`
  display: flex;
  gap: 20px;
`;

export const Indicator = styled.span<IndicatorProps>`
  background-color: ${(props) => (props.active ? "#5B3FFF" : "#EAEDF1")};
  width: 73px;
  height: 5px;
  border-radius: 18px;
`;
